var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lanaya-input", style: _vm.widthStyle }, [
    _c(
      "input",
      _vm._g(
        {
          staticClass: "lanaya-input__inner",
          attrs: {
            min: _vm.$attrs.min,
            max: _vm.$attrs.max,
            placeholder: _vm.$attrs.placeholder,
            type: _vm.whichType
          },
          domProps: { value: _vm.inputValue }
        },
        _vm.allListeners
      )
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c8dbe11", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c8dbe11","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/input/Input.vue
// module id = 49
// module chunks = 0